import { EXCLUDED_ATTRIBUTES, EXCLUDED_TAG_NAMES } from '../../../constants';

interface MutationCallback {
  (mutations: MutationRecord[]): HTMLElement[];
}

interface MutationFilter {
  (mutation: MutationRecord, type: string): HTMLElement[];
}

// MUTATED NODES FILTER
const isNodeExcluded = (node: Node): boolean =>
  !(node instanceof HTMLElement) ||
  EXCLUDED_ATTRIBUTES.some((attr) => node.hasAttribute(attr)) ||
  EXCLUDED_TAG_NAMES.includes(node.nodeName.toLowerCase());

// MAIN DOM MUTATION FILTER
const mutationFilter: MutationFilter = (mutation, type) => {
  if (type === 'childList')
    return [].filter.call(
      mutation.addedNodes,
      (node: Node) => !isNodeExcluded(node),
    );
  if (type === 'attributes')
    return isNodeExcluded(mutation.target)
      ? []
      : ([mutation.target] as HTMLElement[]);

  return [];
};

export const prefilter: MutationCallback = (mutations) => {
  const sorted: HTMLElement[] = [];
  for (const mutation of mutations) {
    sorted.push(...mutationFilter(mutation, mutation.type));
  }
  return sorted;
};
